import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input } from '@angular/core';
import { Campaign } from '@campaign-portal/namespace/entities/campaigns/specs';
import {
	AlarisComplexTooltipDirective,
	AlarisIconDirective,
	AlarisTooltipDirective,
	ChannelUtilsService,
} from '@campaign-portal/components-library';
import { CampaignsService } from '../../../services/campaigns.service';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MessageTemplatePipe } from '@shared/repo';
import { exist, Id } from '@campaign-portal/namespace/common/id';
import { Router } from '@angular/router';
import { CampaignNextRepeatComponent } from './campaign-next-repeat/campaign-next-repeat.component';
import { CampaignSchedulerUtilsService } from '../../../campaign-wizard/campaign-completed/campaign-scheduler/campaign-scheduler-utils.service';

@Component({
	selector: 'app-campaign',
	templateUrl: './campaign.component.html',
	styleUrls: ['./campaign.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TranslateModule,
		AlarisIconDirective,
		AlarisTooltipDirective,
		MessageTemplatePipe,
		AlarisComplexTooltipDirective,
	],
	standalone: true,
})
export class CampaignComponent {
	@Input() campaign!: Campaign;

	readonly CampaignNextRepeatComponent = CampaignNextRepeatComponent;
	readonly destroyRef = inject(DestroyRef);

	constructor(
		public readonly cu: ChannelUtilsService,
		public readonly campaignsService: CampaignsService,
		public readonly schedulerUtils: CampaignSchedulerUtilsService,
		private readonly router: Router
	) {}

	export(id: string, fileName?: string): void {
		this.campaignsService.export(id, fileName).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
	}

	navigateToTemplate(templateID: Id<exist> | undefined): void {
		void this.router.navigate(['campaigns', 'templates'], {
			queryParams: {
				templatesTabs: 'campaignTemplates',
				templateID,
			},
		});
	}
}
